import { ReactComponent as ChevronLeftSvg } from '../../assets/icons/chevron-left.svg';

export const ChevronLeftIcon: SvgIcon = (props) => {
    return <ChevronLeftSvg {...props} />;
};
